<div id="reset-password" fxLayout="column" fusePerfectScrollbar>

  <div id="reset-password-form-wrapper" fxLayout="column" fxLayoutAlign="center center"
    *fuseIfOnDom [@animate]="{value:'*',params:{duration:'300ms',y:'100px'}}">

    <div id="reset-password-form">

      <div class="logo">
        <img src="assets/images/logos/fuse.svg">
      </div>

      <div class="title">PASSWORT FESTLEGEN</div>

      <form name="resetPasswordForm" [formGroup]="resetPasswordForm" novalidate>

        <mat-form-field>
          <input matInput placeholder="E-Mail" formControlName="email">
          @if (resetPasswordFormErrors.email.required) {
            <mat-error>
              E-Mail is required
            </mat-error>
          }
          @if (!resetPasswordFormErrors.email.required && resetPasswordFormErrors.email.email) {
            <mat-error>
              Please enter a valid email address
            </mat-error>
          }
        </mat-form-field>

        <mat-form-field>
          <input type="password" matInput placeholder="Passwort" formControlName="password">
          @if (resetPasswordFormErrors.password.required) {
            <mat-error>
              Password is required
            </mat-error>
          }
        </mat-form-field>

        <mat-form-field>
          <input type="password" matInput placeholder="Passwort (wiederholen)" formControlName="passwordConfirm">
          @if (resetPasswordFormErrors.passwordConfirm.required) {
            <mat-error>
              Password confirmation is required
            </mat-error>
          }
        </mat-form-field>

        <button mat-raised-button class="submit-button" color="accent" (click)="changePass()"
          aria-label="RESET MY PASSWORD" [disabled]="resetPasswordForm.invalid">
          PASSWORD SETZEN
        </button>
      </form>

      <div class="login" fxLayout="row" fxLayoutAlign="center center">
        <a class="link" [routerLink]="'/pages/auth/login'">Zurück zum Login</a>
      </div>

    </div>

  </div>

</div>
